import service from "@/store/services/inspection-form-reminders-service";
import Jsona from "jsona";
import inspectionFormRemindersService from "../services/inspection-form-reminders-service";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios);
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios);
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((note) => ({
      id: inspectionFormRemindersService.id,
      name: inspectionFormRemindersService.name,
    }));
  },
};

const inspectionFormRemindersServices = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default inspectionFormRemindersServices;
